import {
  GET_INSTALLATIONS_LIST_IN_PROGRESS,
  GET_INSTALLATIONS_LIST_SUCCESS,
  GET_INSTALLATIONS_LIST_FAIL,
  GET_INSTALLATIONS_FILTERS_IN_PROGRESS,
  GET_INSTALLATIONS_FILTERS_SUCCESS,
  GET_INSTALLATIONS_FILTERS_FAIL,
  GET_INSTALLATIONS_COUNT_IN_PROGRESS,
  GET_INSTALLATIONS_COUNT_SUCCESS,
  GET_INSTALLATIONS_COUNT_FAIL,
  GET_INSTALLATION_INFO_IN_PROGRESS,
  GET_INSTALLATION_INFO_SUCCESS,
  GET_INSTALLATION_INFO_FAIL,
  UPDATE_INSTALLATION_IN_PROGRESS,
  UPDATE_INSTALLATION_SUCCESS,
  UPDATE_INSTALLATION_FAIL,
  RESET_INSTALLATION_STATE,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";
import { MARK_ANALYSIS_AS_VIEWED_SUCCESS } from "../../analysis/constants";

const initialState = {
  list: [],
  inProgress: false,
  info: undefined,
  error: false,
  filters: {},
  filtersInProgress: false,
  count: 0,
  countInProgress: false,
  saved: false,
  errorMessage: undefined,
  errorCode: undefined,
};

/**
 * Installations reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function installations(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_INSTALLATIONS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_INSTALLATIONS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_INSTALLATIONS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case GET_INSTALLATIONS_FILTERS_IN_PROGRESS:
      return {
        ...state,
        filtersInProgress: true,
        error: false,
      };

    case GET_INSTALLATIONS_FILTERS_SUCCESS:
      return {
        ...state,
        filters: payload.filters,
        filtersInProgress: false,
      };

    case GET_INSTALLATIONS_FILTERS_FAIL:
      return {
        ...state,
        filtersInProgress: false,
        error: true,
      };

    case GET_INSTALLATIONS_COUNT_IN_PROGRESS:
      return {
        ...state,
        countInProgress: true,
        error: false,
      };

    case GET_INSTALLATIONS_COUNT_SUCCESS:
      return {
        ...state,
        count: payload.count,
        countInProgress: false,
      };

    case GET_INSTALLATIONS_COUNT_FAIL:
      return {
        ...state,
        countInProgress: false,
        error: true,
      };

    case GET_INSTALLATION_INFO_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_INSTALLATION_INFO_SUCCESS:
      return {
        ...state,
        info: payload.info,
        inProgress: false,
      };

    case GET_INSTALLATION_INFO_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case UPDATE_INSTALLATION_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        saved: false,
        error: false,
        errorMessage: undefined,
        errorStatus: undefined,
      };

    case UPDATE_INSTALLATION_SUCCESS:
      return {
        ...state,
        inProgress: false,
        saved: true,
        error: false,
      };

    case UPDATE_INSTALLATION_FAIL:
      return {
        ...state,
        inProgress: false,
        saved: false,
        errorMessage: payload.message,
        errorCode: payload.code,
      };
    
    case MARK_ANALYSIS_AS_VIEWED_SUCCESS:
      return {
        ...state,
        info: state.info ? {
          ...state.info,
          analyses: state.info.analyses?.map(analysis => {
            if (analysis.uuid === payload.uuid) {
              return {
                ...analysis,
                resultViewedAt: new Date(),
                hasResultToView: false,
              };
            }
            return analysis;
          }),
        } : state.info
      };

    case RESET_INSTALLATION_STATE:
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
